import { createFileRoute } from "@tanstack/react-router";
import { ListaComprasPage } from "@/paginas/lista-compras";

export const Route = createFileRoute("/_authenticated/lista-compras")({
  head: () => ({
    meta: [
      { title: "Listas de compras — Milky Moo Palmares" },
      {
        name: "description",
        content: "Listas de compras da sorveteria, com histórico e impressão.",
      },
      { property: "og:title", content: "Listas de compras — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Listas de compras da sorveteria, com histórico e impressão.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ListaComprasPage,
});
